import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { grey25 } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';

import Panel from './Panel';
import { REFINE_MAX_WIDTH, REFINE_ZINDEX } from '../../constants';

const PanelWrapper = styled.div`
    background-color: rgba(243, 243, 244, 0.8);
    cursor: pointer;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: ${REFINE_ZINDEX};

    ${breakpoint.small} {
        position: absolute;
        right: 0;
        bottom: 0;
        width: auto;
    }
`;

const StyledPanel = styled(Panel)`
    background-color: ${grey25};
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    ${breakpoint.medium} {
        max-width: ${REFINE_MAX_WIDTH}px;
    }
`;

const RefineSearchPanel = ({ onPanelClose, ...props }) => (
    <PanelWrapper>
        <StyledPanel
            {...props}
            data-test="search-refine-panel"
            onCloseCallback={onPanelClose}
        />
    </PanelWrapper>
);

RefineSearchPanel.propTypes = {
    onPanelClose: PropTypes.func,
};

export {
    RefineSearchPanel as default,
    RefineSearchPanel,
};
